<script setup lang="ts">
import { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']

  // rounded positions
  topRight?: boolean
  topLeft?: boolean
  bottomRight?: boolean
  bottomLeft?: boolean

  top?: boolean
  bottom?: boolean
  left?: boolean
  right?: boolean

  none?: boolean
}>()

const calculateRoundedClasses = () => {
  const { topRight, topLeft, bottomRight, bottomLeft, top, bottom, left, right, none } = props

  if (none) return 'rounded-none'

  // if everything is false, return rounded-lg
  if (!topRight && !topLeft && !bottomRight && !bottomLeft && !top && !bottom && !left && !right)
    return 'rounded-lg'

  return cn({
    'rounded-tl-lg': topLeft,
    'rounded-tr-lg': topRight,
    'rounded-bl-lg': bottomLeft,
    'rounded-br-lg': bottomRight,
    'rounded-t-lg': top,
    'rounded-b-lg': bottom,
    'rounded-l-lg': left,
    'rounded-r-lg': right,
  })
}
</script>
<template>
  <section
    :class="
      cn('bg-white p-6 border border-slate-200 shadow-sm', calculateRoundedClasses(), props.class)
    "
  >
    <slot />
  </section>
</template>
